import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

// Shared footer used on every page
function Footer() {
  return (
    <footer className="bg-slate-950 border-t border-slate-800 py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          <div>
            <Link to="/" className="flex items-center space-x-3 mb-4">
              <img
                src="https://customer-assets.emergentagent.com/job_design-inspiration-4/artifacts/f59reduc_logo.jpg"
                alt="Soccer Sphere"
                className="h-14 w-14 object-contain"
              />
              <span className="text-xl font-bold text-white">Soccer Sphere</span>
            </Link>
            <p className="text-gray-400">Building champions on and off the field.</p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Programs</h3>
            <ul className="space-y-2 text-gray-400">
              <li><Link to="/recreational" className="hover:text-white transition">Recreational</Link></li>
              <li><Link to="/precomp" className="hover:text-white transition">Pre-Comp</Link></li>
              <li><Link to="/competitive" className="hover:text-white transition">Competitive</Link></li>
              <li><Link to="/elite" className="hover:text-white transition">Elite</Link></li>
              <li><Link to="/after-school" className="hover:text-white transition">After-School</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">About</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="/#values" className="hover:text-white transition">Our Values</a></li>
              <li><a href="/#testimonials" className="hover:text-white transition">Testimonials</a></li>
              <li><a href="/#faq" className="hover:text-white transition">FAQ</a></li>
              <li><Link to="/contact" className="hover:text-white transition">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span>2010 El Camino Real #1418<br />Santa Clara, CA 95050</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="w-4 h-4" />
                <a href="tel:+16692045870" className="hover:text-white transition" data-testid="footer-phone-link">
                  +1 (669) 204-5870
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="w-4 h-4" />
                <a href="mailto:info@soccersphere.net" className="hover:text-white transition">
                  info@soccersphere.net
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 text-center text-gray-400 text-sm">
          <p>&copy; 2025 Soccer Sphere. All rights reserved. Building champions on and off the field.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
